// extracted by mini-css-extract-plugin
export var component = "content-module--component--KSRXh";
export var light = "content-module--light--v9MSU";